import { ThemeOptions } from '@mui/material';
import { coastThemeOptions } from '@vayufp/coast-components';

const coastPalette = coastThemeOptions.palette!;

const palette: ThemeOptions['palette'] = {
  ...coastPalette,
  background: {
    ...coastPalette.background,
    default: coastPalette.common?.white,
  },
};

export { palette };
